import styles from 'components/MultiSelect/MultiSelect.module.css';
import { Label } from 'components/Label';
import { Button } from 'components';

export interface MultiSelectHeaderProps {
  label: string;
  clearTrigger?: string;
  onClear?: () => void;
}

export function MultiSelectHeader({ label, clearTrigger, onClear }: MultiSelectHeaderProps) {
  return (
    <header className={styles['multi-select__header']}>
      <Label htmlFor="multi-select-list">{label}</Label>
      {clearTrigger && (
        <Button variant={'blank'} onClick={onClear}>
          {clearTrigger}
        </Button>
      )}
    </header>
  );
}
